import routingNumberList from './routing-number-list';

/**
 * Validate routing numbers
 * @param {number} value routing numbers containing the last 4 digits to verify
 * example: ******1234
 * example: 1234
 *
 * @returns {boolean} returns if the routing number is valid
 */
export default function validateRouting4LastDigits(value) {
  return (
    routingNumberList.find((nb) => {
      const nbLength = nb.length;
      const valueLength = value.length;
      return (
        nb[nbLength - 4] === value[valueLength - 4] &&
        nb[nbLength - 3] === value[valueLength - 3] &&
        nb[nbLength - 2] === value[valueLength - 2] &&
        nb[nbLength - 1] === value[valueLength - 1]
      );
    }) !== undefined
  );
}
